import api from '../../services/api';

/*
 * The clients of a warehouse: who keeps goods there, and how each one wants to
 * work. A client is a contract between the warehouse and a company.
 */

/**
 * The contracts of the warehouses in reach, or of one of them. Each row says
 * whether the caller can change it (`can_manage`): the rules of a warehouse
 * are its holder's.
 *
 * @param {{warehouse?: number}} params
 */
export const getWarehouseClientsRequest = async (params) => {
  return await api.get('warehouses/clients/', { params });
};

/**
 * Changes how a client works in a warehouse. Only the operating preferences
 * travel: the module, the quota and the term are commercial and are set
 * elsewhere.
 *
 * @param {number} contractId
 * @param {{auto_reserve?: boolean, require_picking?: boolean, seller_can_reserve?: boolean}} payload
 */
export const updateWarehouseClientRequest = async (contractId, payload) => {
  return await api.patch(`warehouses/clients/${contractId}/`, payload);
};
